// import ReactGA from 'react-ga';
// import { IS_DEVEL } from 'client/constants';
// import debug from 'debug';

// const log = debug('app:client:analytics');
// let options = {};

// if (IS_DEVEL) {
// 	options = { debug: false };
// }

// export const tracker = {
// 	init: function init(id) {
// 		if (typeof window === 'undefined') {
// 			return;
// 		}
// 		if (!id) {
// 			console.warn('There is no google analytics ID.');
// 			return;
// 		}
// 		log('init', id);
// 		ReactGA.initialize(id, options);
// 	},
// 	pageview: function pageview(...args) {
// 		log('pageview', ...args);
// 		ReactGA.pageview(...args);
// 	},
// 	event: function event(...args) {
// 		log('event', ...args);
// 		ReactGA.event(...args);
// 	},
// 	ga: function ga(args) {
// 		log('ga', ...args);
// 		ReactGA.ga(...args);
// 	},
// };

// export function track({ type, payload }) {
// 	try {
// 		tracker[type](payload);
// 	} catch (error) {
// 		if (IS_DEVEL) {
// 			console.warn('Failed to track analytics event', error);
// 		}
// 	}
// }

// export const events = {
// 	pageView: url =>
// 		track({
// 			type: 'ga',
// 			payload: ['send', 'pageview', `/${url}`],
// 		}),
// 	onMakoLogoClick: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click mako logo' },
// 		});
// 	},
// 	onProjectLogoClick: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click activity logo' },
// 		});
// 	},
// 	onPartnerLogoClick: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click customer logo' },
// 		});
// 	},
// 	onStartClick: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click Start' },
// 		});
// 	},
// 	onItemSelected: name => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click Things', label: name },
// 		});
// 	},
// 	onFinishClick: items => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Done', label: items },
// 		});
// 	},
// 	onShowMoreClick: name => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click more info', label: name },
// 		});
// 	},
// 	onPlayVideoClick: name => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Play video', label: name },
// 		});
// 	},
// 	onSendEmailClick: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click Send me email' },
// 		});
// 	},
// 	onBackClick: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click Back' },
// 		});
// 	},
// 	onFormResults: title => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Results', label: title },
// 		});
// 	},
// 	onSubmitUserForm: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click send form' },
// 		});
// 	},
// 	onItemLinkClick: name => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click Item link', label: name },
// 		});
// 	},
// 	onShareClick: type => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Share activity', label: type },
// 		});
// 	},
// 	onShareResultClick: type => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Share Result', label: type },
// 		});
// 	},
// 	onItemTextClick: type => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click more info', label: type },
// 		});
// 	},
// 	onBottomBannerClick: () => {
// 		track({
// 			type: 'event',
// 			payload: { category: 'Checklist', action: 'Click customer banner' },
// 		});
// 	},
// };

// @flow
export const analytics = {
	gtag: {
		event: (action: string, params?: Record<string, string>) => {
			// @ts-expect-error gtag is added in html.head:
			const { gtag } = window;

			if (gtag) {
				console.info('gtag:', action, params);
				gtag('event', action, params);
			} else {
				console.info('%cgtag is undefined', 'color: red');
			}
		},
	},
};
